export class PopupSearchStringManager {
    constructor() {
        this.options = [];
        this.searchString = '';
        this.appendTimerId = undefined;
    }
    getOptionToFocus(event, currentFocusedOption) {
        if (!this.isPrintableChar(event) || !this.options) {
            this.reset();
            return undefined;
        }
        this.appendNewChar(event.key);
        const matchedOption = this.getOptionBySearchString(currentFocusedOption);
        if (!matchedOption) {
            this.reset();
        }
        return matchedOption;
    }
    isPrintableChar(event) {
        return event.key.length === 1 && !event.altKey && !event.ctrlKey && !event.metaKey;
    }
    appendNewChar(char) {
        if (this.appendTimerId !== undefined) {
            clearTimeout(this.appendTimerId);
        }
        this.appendTimerId = setTimeout(() => {
            this.searchString = '';
            this.currentTimerOption = undefined;
        }, 500);
        this.searchString += char;
        return this.searchString;
    }
    getOptionBySearchString(currentFocusedOption) {
        if (currentFocusedOption &&
            currentFocusedOption === this.currentTimerOption &&
            matches(currentFocusedOption, this.searchString)) {
            // do not change the option if the current option still matches and the timer hasn't run out
            return currentFocusedOption;
        }
        const startIndex = Math.max(0, this.options.indexOf(currentFocusedOption) + 1);
        const optionsToSearch = [
            ...this.options.slice(startIndex),
            ...this.options.slice(0, startIndex),
        ];
        const foundMatches = optionsToSearch.filter((option) => matches(option, this.searchString));
        this.currentTimerOption = foundMatches[0];
        return this.currentTimerOption;
    }
    reset() {
        clearTimeout(this.appendTimerId);
        this.currentTimerOption = undefined;
        this.searchString = '';
    }
}
function matches(option, searchString) {
    return option.textContent.trim().toLowerCase().startsWith(searchString);
}
//# sourceMappingURL=popup-search-string-manager.js.map